import React, { createContext, useContext, useState, useEffect } from 'react';
import { AuthContextType } from './authContext.type';
import { StorageKey } from '../../utils/helper.type';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'auth-context';
const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({
  children,
  testIdPrefix,
}: {
  children: React.ReactNode;
  testIdPrefix?: string;
}) => {
  const prefix: string = testIdPrefix || idPrefix;
  const [isDisplayPIN, setIsDisplayPIN] = useState<boolean | null>(null);

  const [accessToken, setAccessToken] = useState<string | null>(() =>
    localStorage.getItem(StorageKey.ACCESS_TOKEN),
  );

  const [idpToken, setIdpToken] = useState<string | null>(() =>
    localStorage.getItem(StorageKey.IDP_TOKEN),
  );

  const [staffPinState, setStaffPinState] = useState<string | null>(() =>
    localStorage.getItem(StorageKey.STAFF_PIN),
  );

  const setStaffPin = (pin: string | null) => {
    setStaffPinState(pin);
    if (pin) {
      localStorage.setItem(StorageKey.STAFF_PIN, pin);
    } else {
      localStorage.removeItem(StorageKey.STAFF_PIN);
    }
  };

  useEffect(() => {
    if (accessToken) {
      localStorage.setItem(StorageKey.ACCESS_TOKEN, accessToken);
    } else {
      localStorage.removeItem(StorageKey.ACCESS_TOKEN);
    }
  }, [accessToken]);

  return (
    <AuthContext.Provider
      value={{
        isDisplayPIN,
        setIsDisplayPIN,
        accessToken,
        setAccessToken,
        idpToken,
        setIdpToken,
        staffPin: staffPinState,
        setStaffPin,
      }}
    >
      <div {...getIdAttributes(prefix, 'provider')}>{children}</div>
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used inside AuthProvider');
  return context;
};
